// A device's kind as a label and an icon (the API's kinds: docs/03 "Device").
import { Browser, DeviceMobile, DeviceTablet, type Icon, Lifebuoy } from "@phosphor-icons/react";

import { messages } from "../i18n";

export const KINDS: Record<string, Icon> = {
  iphone: DeviceMobile,
  ipad: DeviceTablet,
  browser: Browser,
  recovery: Lifebuoy,
  android: DeviceMobile,
};

/** The kind's label in the active language; an unknown kind as the API sent it. */
export function kindLabel(kind: string): string {
  const labels: Partial<Record<string, string>> = messages().devices.kinds;
  return labels[kind] ?? kind;
}
